export const SET_PRODUCTIONORDERS = 'SET_PRODUCTIONORDERS';
export const SET_MATERIALS = 'SET_MATERIALS';
export const SET_ARTICLES = 'SET_ARTICLES';
export const REFRESH_ORDERS = 'REFRESH_ORDERS';
export const SET_FINISHEDORDERIDS = 'SET_FINISHEDORDERIDS';



